module.exports = __webpack_public_path__ + "img/mm_b1_img4.084d74d9.png";